export default class Parameter {
    constructor(parameters) {

        this.ActiveDirectoryAllowedUserGroups = "";
        this.ActiveDirectoryAuthEnabled = false;
        this.ActiveDirectoryDomain = "";
        this.ActiveDirectoryServerPath = "";
        this.DashboardCacheEnabled = false;
        this.JobsExecutionTime = "";
        this.SAMLEnabled = false;
        this.SAMLCertificate = "";
        this.SAMLEndpoint = "";
        this.SupportedFileFormats = "";
        this.WebApiURL = "";
        this.AutorecognitionApiURL = "";
        this.WebsiteURL = "";
        this.SwissIDEnabled = false;
        this.SwissIDLogin = "";
        this.SwissIDPassword = "";

        if (parameters) {
            this.ActiveDirectoryAllowedUserGroups = parameters.find(p => p.Name == 'ActiveDirectoryAllowedUserGroups').Value;
            this.ActiveDirectoryAuthEnabled = parameters.find(p => p.Name == 'ActiveDirectoryAuthEnabled').Value == "true";
            this.ActiveDirectoryDomain = parameters.find(p => p.Name == 'ActiveDirectoryDomain').Value;
            this.ActiveDirectoryServerPath = parameters.find(p => p.Name == 'ActiveDirectoryServerPath').Value;
            this.DashboardCacheEnabled = parameters.find(p => p.Name == 'DashboardCacheEnabled').Value == "true";
            this.JobsExecutionTime = parameters.find(p => p.Name == 'JobsExecutionTime').Value;
            this.SAMLCertificate = parameters.find(p => p.Name == 'SAMLCertificate').Value;
            this.SAMLEndpoint = parameters.find(p => p.Name == 'SAMLEndpoint').Value;
            this.SAMLEnabled = (this.SAMLCertificate && this.SAMLEndpoint);
            this.SupportedFileFormats = parameters.find(p => p.Name == 'SupportedFileFormats').Value;
            this.WebApiURL = parameters.find(p => p.Name == 'WebApiURL').Value;
            this.AutorecognitionApiURL = parameters.find(p => p.Name == 'AutorecognitionApiURL').Value;
            this.WebsiteURL = parameters.find(p => p.Name == 'WebsiteURL').Value;
            this.SwissIDLogin = parameters.find(p => p.Name == 'SwissIDLogin').Value;
            this.SwissIDPassword = parameters.find(p => p.Name == 'SwissIDPassword').Value;
            this.SwissIDEnabled = (this.SwissIDLogin && this.SwissIDPassword);
        }
    }

    toDto() {
        var parameters = [];
        parameters.push({ Name: "ActiveDirectoryAllowedUserGroups", Value: this.ActiveDirectoryAllowedUserGroups })
        parameters.push({ Name: "ActiveDirectoryAuthEnabled", Value: this.ActiveDirectoryAuthEnabled ? "true" : "false" })
        parameters.push({ Name: "ActiveDirectoryDomain", Value: this.ActiveDirectoryDomain })
        parameters.push({ Name: "ActiveDirectoryServerPath", Value: this.ActiveDirectoryServerPath })
        parameters.push({ Name: "DashboardCacheEnabled", Value: this.DashboardCacheEnabled })
        parameters.push({ Name: "JobsExecutionTime", Value: this.JobsExecutionTime })
        parameters.push({ Name: "SAMLCertificate", Value: this.SAMLEnabled ? this.SAMLCertificate : "" })
        parameters.push({ Name: "SAMLEndpoint", Value: this.SAMLEnabled ? this.SAMLEndpoint : "" })
        parameters.push({ Name: "SupportedFileFormats", Value: this.SupportedFileFormats })
        parameters.push({ Name: "WebApiURL", Value: this.WebApiURL })
        parameters.push({ Name: "AutorecognitionApiURL", Value: this.AutorecognitionApiURL })
        parameters.push({ Name: "WebsiteURL", Value: this.WebsiteURL })
        parameters.push({ Name: "SwissIDLogin", Value: this.SwissIDLogin })
        parameters.push({ Name: "SwissIDPassword", Value: this.SwissIDPassword })
        return parameters;
    }
}
